module.exports = __webpack_public_path__ + "/img/Sot143-Custom-Footprint-NGYz8g.svg";